import type { ReactNode } from 'react';

/**
 * An empty screen is an invitation to act, not an apology. Say what would be
 * here and what to do about it.
 */
export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-6 py-16 text-center">
      <p className="font-medium text-ink">{title}</p>
      {description && <p className="max-w-sm text-xs text-ink-3">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}

/**
 * Errors state what happened and what to do, in the interface's voice. They
 * do not apologise and they are never vague.
 */
export function ErrorState({
  title = 'Could not load this',
  message,
  onRetry,
}: {
  title?: string;
  message?: string;
  onRetry?: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-6 py-16 text-center">
      <p className="font-medium text-ink">{title}</p>
      {message && <p className="max-w-md text-xs text-ink-3">{message}</p>}
      {onRetry && (
        <button type="button" className="btn btn-secondary btn-sm mt-2" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}
